/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrganizationPortalAdmin,
    OrganizationPortalAdminFromJSON,
    OrganizationPortalAdminFromJSONTyped,
    OrganizationPortalAdminToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationPortalAdminsResponse
 */
export interface OrganizationPortalAdminsResponse {
    /**
     * 
     * @type {Array<OrganizationPortalAdmin>}
     * @memberof OrganizationPortalAdminsResponse
     */
    results: Array<OrganizationPortalAdmin>;
}

export function OrganizationPortalAdminsResponseFromJSON(json: any): OrganizationPortalAdminsResponse {
    return OrganizationPortalAdminsResponseFromJSONTyped(json, false);
}

export function OrganizationPortalAdminsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationPortalAdminsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(OrganizationPortalAdminFromJSON)),
    };
}

export function OrganizationPortalAdminsResponseToJSON(value?: OrganizationPortalAdminsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(OrganizationPortalAdminToJSON)),
    };
}


